/**
 * This is used when the library is loaded asynchronously.
 *
 * It should be at the end of the index.ts file to ensure it is executed last.
 *
 * However, it is done in a setTimeout to wait until the current event loop has finished.
 * This ensures that it is at the end of the execution stack for the library. (in the event that
 * some other code is loaded after this function is called, maybe builder related code)
 *
 * Ref: http://blog.errorception.com/2012/01/writing-quality-third-party-js-part-3.html
 *
 */
export function setupAsyncLoading(): void {
  window.setTimeout(() => {
    if (window.slAsyncInit) {
      window.slAsyncInit();
    }
  }, 0);
}
